import React, { useMemo } from "react";
import ReactEcharts from "echarts-for-react";
import { useTranslation } from "react-i18next";
import { BLUE, GREEN, DARKGREEN, YELLOW, DARKBLUE } from "@helper/colors";

const palette = [GREEN, BLUE, YELLOW, DARKGREEN, DARKBLUE];

export default function TopSpeciesChart({ data, total }) {
  const { t } = useTranslation();
  const safeData = data || [];
  const chartHeight = Math.max(180, Math.min(280, safeData.length * 60));
  const style = {
    height: `${chartHeight}px`,
    width: "100%",
  };

  const chartData = useMemo(() => {
    return safeData.map((item, index) => ({
      name: item.name,
      value: item.count,
      itemStyle: { color: palette[index % palette.length] },
    }));
  }, [safeData]);

  const option = useMemo(() => {
    return {
      grid: {
        left: 8,
        right: 16,
        bottom: 16,
        top: 12,
        containLabel: true,
      },
      xAxis: {
        type: "value",
        axisLine: { show: false },
        axisTick: { show: false },
        splitLine: { lineStyle: { color: "#eef0f2" } },
        axisLabel: { fontSize: 11 },
      },
      yAxis: {
        type: "category",
        data: chartData.map((item) => item.name),
        axisTick: { show: false },
        axisLine: { show: false },
        axisLabel: { fontSize: 12 },
      },
      series: [
        {
          type: "bar",
          barWidth: 28,
          data: chartData,
          label: {
            show: false,
          },
        },
      ],
    };
  }, [chartData]);

  if (!chartData.length) {
    return <div className="dashboard-empty">{t("dashboard.no_data")}</div>;
  }

  return (
    <div className="dashboard-top-species">
      <ReactEcharts option={option} style={style} notMerge />
      <div className="dashboard-top-list">
        {safeData.map((item, index) => {
          const percentage = total ? Math.round((item.count / total) * 100) : 0;
          return (
            <div className="dashboard-top-item" key={item.name}>
              <div className="dashboard-top-meta">
                <span
                  className="dashboard-top-dot"
                  style={{ background: palette[index % palette.length] }}
                />
                <div>
                  <div className="dashboard-top-name">{item.name}</div>
                  <div className="dashboard-top-count">
                    {item.count} {t("trees_short")}
                  </div>
                </div>
              </div>
              <span className="dashboard-top-percent">{percentage}%</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
